import { theme } from '../../theme';
export const colorMap = {
    blue: (transparent) => transparent
        ? {
            backgroundColor: theme.colors.BB20T,
            color: theme.colors.BB200,
        }
        : {
            backgroundColor: theme.colors.BB20,
            color: theme.colors.BB200,
        },
    green: (transparent) => transparent
        ? {
            backgroundColor: theme.colors.GR20T,
            color: theme.colors.GR200,
        }
        : {
            backgroundColor: theme.colors.GR20,
            color: theme.colors.GR200,
        },
    pink: (transparent) => transparent
        ? {
            backgroundColor: theme.colors.PI20T,
            color: theme.colors.PI200,
        }
        : {
            backgroundColor: theme.colors.PI20,
            color: theme.colors.PI200,
        },
    purple: (transparent) => transparent
        ? {
            backgroundColor: theme.colors.PU20T,
            color: theme.colors.PU200,
        }
        : {
            backgroundColor: theme.colors.PU20,
            color: theme.colors.PU200,
        },
    yellow: (transparent) => transparent
        ? {
            backgroundColor: theme.colors.YE20T,
            color: theme.colors.YE200,
        }
        : {
            backgroundColor: theme.colors.YE20,
            color: theme.colors.YE200,
        },
    teal: (transparent) => transparent
        ? {
            backgroundColor: theme.colors.TE20T,
            color: theme.colors.TE200,
        }
        : {
            backgroundColor: theme.colors.TE20,
            color: theme.colors.TE200,
        },
    red: (transparent) => transparent
        ? {
            backgroundColor: theme.colors.RE20T,
            color: theme.colors.RE200,
        }
        : {
            backgroundColor: theme.colors.RE20,
            color: theme.colors.RE200,
        },
};
export const getChipStyles = (color = 'blue', transparent = false) => colorMap[color](transparent);
//# sourceMappingURL=styles.js.map